module.exports = __webpack_public_path__ + "static/media/switch.38bdc5cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/switch.svg
// module id = 179
// module chunks = 0